<template>
  <div class="md-layout">
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon pull-left">
          <md-icon>directions_boat_filled</md-icon>

        </div>
        <h4 class="title">Port Details</h4>

          <md-button @click="goBack" class="md-primary md-dense pull-right">
            Back to List
          </md-button>
        <md-button class="md-white md-primary"
                   @click="goToEdit(port.id)"
                   style="margin: 0.2rem">
          Edit
        </md-button>
      </md-card-header>
    </md-card>
    <div class="md-layout-item md-size-20">

    </div>
    <div class="md-layout-item md-size-80"></div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
            <nav-tabs-card>
              <template slot="content">
                <span class="md-nav-tabs-title">Tasks:</span>
                <md-tabs class="md-primary md-white" md-alignment="left">
                  <md-tab id="tab-home" md-label="Details" md-icon="description">
                    <md-table>
                      <md-table-row>
                        <md-table-cell>Name</md-table-cell>
                        <md-table-cell>{{ port.name }}</md-table-cell>
                      </md-table-row>
                      <md-table-row>
                        <md-table-cell>Code</md-table-cell>
                        <md-table-cell>{{ port.code }}</md-table-cell>
                      </md-table-row>
                      <md-table-row>
                        <md-table-cell>Short Name</md-table-cell>
                        <md-table-cell>{{ port.short_name }}</md-table-cell>
                      </md-table-row>
                      <md-table-row>
                        <md-table-cell>Station</md-table-cell>
                        <md-table-cell>{{ station.name }}</md-table-cell>
                      </md-table-row>
                    </md-table>
                  </md-tab>

                  <md-tab id="tab-workplace" md-label="Workplace" md-icon="apartment">

                  </md-tab>

                  <md-tab id="tab-labourer" md-label="Labourer" md-icon="engineering">

                  </md-tab>

                  <md-tab id="tab-takeon" md-label="Take on s" md-icon="add_task">

                  </md-tab>
                </md-tabs>
              </template>
            </nav-tabs-card>
          </div>

        </div>
  </div>


</template>

<script>
import { NavTabsCard } from '@/components';

export default {
    components: {
        NavTabsCard,

    },
    data () {
        return {
            selected: [],
            responsive: false,
            port: {
                type: 'ports',
                name: null,
                id: null,
                short_name: null,
                code: null,
                station_id: null,
            },
            station: {
                id: null,
                name: null,
            },
            firstTabs: [
                {
                    tab: 'Sign contract for "What are conference organizers afraid of?"'
                },
                {
                    tab: 'Lines From Great Russian Literature? Or E-mails From My Boss?'
                },
                {
                    tab:
              'Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit'
                }
            ],
            secondTabs: [
                {
                    tab: 'Sign contract for "What are conference organizers afraid of?"'
                },
                {
                    tab: 'Lines From Great Russian Literature? Or E-mails From My Boss?'
                },
                {
                    tab:
              'Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit'
                }
            ],
            thirdTabs: [
                {
                    tab: 'Sign contract for "What are conference organizers afraid of?"'
                },
                {
                    tab: 'Lines From Great Russian Literature? Or E-mails From My Boss?'
                },
                {
                    tab:
              'Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit'
                }
            ],
            users: [
                {
                    id: 1,
                    name: 'Dakota Rice',
                    salary: '$36,738',
                    country: 'Niger'
                },
                {
                    id: 2,
                    name: 'Minerva Hooper',
                    salary: '$23,738',
                    country: 'Curaçao'
                },
                {
                    id: 3,
                    name: 'Sage Rodriguez',
                    salary: '$56,142',
                    country: 'Netherlands'
                },
                {
                    id: 4,
                    name: 'Philip Chaney',
                    salary: '$38,735',
                    country: 'Korea, South'
                }
            ]
        };
    },

    created () {
        this.get();
    },

    methods: {
        goToEdit (id) {
            this.$router.push({ name: 'Edit Port', params: { id } });
        },
        onSelect: function (items) {
            this.selected = items;
        },
        onResponsiveInverted () {
            if (window.innerWidth < 768) {
                this.responsive = true;
            } else {
                this.responsive = false;
            }
        },
        async get () {
            try {
                const params = {
                    id: this.$route.params.id,
                    include: 'station,labourers,workplaces'
                };
                const id = this.$route.params.id;
                await this.$store.dispatch('ports/show', params);
                this.port = this.$store.getters['ports/port'];
                this.station = this.port.station;
            } catch (e) {
                this.notifyException(e);
            }
        },

        goBack () {
            this.$router.push({ name: 'List Ports' });
        },


    },
    mounted () {
        this.onResponsiveInverted();
        window.addEventListener('resize', this.onResponsiveInverted);
    },
    beforeDestroy () {
        window.removeEventListener('resize', this.onResponsiveInverted);
    }
};
</script>

<style lang="css"></style>
